import { render, staticRenderFns } from "./zpDetail.vue?vue&type=template&id=774dae7f&scoped=true"
import script from "./zpDetail.vue?vue&type=script&lang=js"
export * from "./zpDetail.vue?vue&type=script&lang=js"
import style0 from "./zpDetail.vue?vue&type=style&index=0&id=774dae7f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dae7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774dae7f')) {
      api.createRecord('774dae7f', component.options)
    } else {
      api.reload('774dae7f', component.options)
    }
    module.hot.accept("./zpDetail.vue?vue&type=template&id=774dae7f&scoped=true", function () {
      api.rerender('774dae7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/detail/zpDetail.vue"
export default component.exports